/* Stallion Keys quick-buy panel (Steve 2026-10-22: "I like it" - the phone preview at claude.ai/artifact/M7eb4ofHftasENcApKT8g3).
   Search and vehicle-search result cards for products with several options get "See options" instead of the option list;
   tapping it slides up a panel styled like the product page: the product's own option headings ("Number of Buttons",
   "Select Item Condition") as rows of pill buttons, one price, one red Add to cart.
   Works on top of the existing cards (assets/stallion-vehicle-search.js and assets/stallion-search-results.js are not
   changed): it hides the card's option list (select[data-var]) and, on Add to cart, sets that list to the chosen option
   and presses the card's own Add to cart, so adding to the cart works exactly as before (cart drawer, bubble, messages).
   Data: /products/<handle>.js (options, every option's price and stock, option photos). Remove the script tag in
   snippets/stallion-main-search.liquid to switch it off. */
(function () {
  "use strict";
  if (window.__SK_QUICKBUY__) return;
  window.__SK_QUICKBUY__ = true;

  var LABEL = "See options";
  var NOTE = "";       // optional line under the options (e.g. what each condition means), empty = none
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency: cur }); } catch (e) { fmt = null; }
  var money = function (cents) { var n = (cents || 0) / 100; return fmt ? fmt.format(n) : "$" + n.toFixed(2); };
  var img = function (src, w) {
    if (!src) return "";
    var u = String(src); if (u.indexOf("//") === 0) u = "https:" + u;
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + (w || 500);
  };

  /* ---------- styles (scoped to .skqb; colors = store brand: Midnight #080819, Stallion Red #d51313) ---------- */
  var CSS = [
    ".skqb-scrim{position:fixed;inset:0;background:rgba(8,8,25,.55);opacity:0;pointer-events:none;transition:opacity .2s;z-index:2147483600}",
    ".skqb{position:fixed;left:0;right:0;bottom:0;z-index:2147483601;max-width:520px;height:92vh;height:92dvh;margin:0 auto;background:#fff;color:#080819;",
    "border-radius:24px 24px 0 0;transform:translateY(102%);transition:transform .28s ease;display:flex;flex-direction:column;",
    "font-family:inherit;font-size:15px;line-height:1.45;-webkit-text-size-adjust:100%}",
    "html.skqb-open .skqb-scrim{opacity:1;pointer-events:auto}html.skqb-open .skqb{transform:none}html.skqb-open,html.skqb-open body{overflow:hidden}",
    "@media (prefers-reduced-motion:reduce){.skqb,.skqb-scrim{transition:none}}",
    ".skqb *{box-sizing:border-box}",
    ".skqb-grab{width:44px;height:5px;border-radius:3px;background:#e3e4e8;position:absolute;left:50%;top:8px;transform:translateX(-50%)}",
    ".skqb-top{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:18px 16px 0 22px}",
    ".skqb-kind{font-size:14px;color:#5d5e6e;min-width:0}",
    ".skqb-x{flex:none;width:40px;height:40px;border-radius:50%;border:0;background:#080819;color:#fff;font:inherit;font-size:22px;line-height:1;cursor:pointer}",
    ".skqb-body{flex:1;overflow:auto;padding:2px 22px 18px;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}",
    ".skqb h2{margin:2px 0 0;font-size:22px;line-height:1.2;font-weight:800;color:#080819;letter-spacing:-.01em}",
    ".skqb-pn{font-size:12.5px;color:#5d5e6e;margin-top:4px;overflow-wrap:anywhere}",
    ".skqb-pn a{color:#080819;font-weight:600;text-decoration:underline;white-space:nowrap}",
    ".skqb-photo{display:flex;justify-content:center;margin:6px 0 0;min-height:120px}",
    ".skqb-photo img{width:min(60%,210px);aspect-ratio:1/1;object-fit:contain}",
    ".skqb-group{margin-top:16px;border:0;padding:0;min-width:0}",
    ".skqb-group legend{padding:0;margin:0 0 12px;font-size:14.08px;font-weight:700;color:#080819}",
    /* option pills copied from the product page's variant picker */
    ".skqb-pills{display:flex;flex-wrap:wrap;gap:12px}",
    ".skqb-pills button{position:relative;min-width:64px;padding:12px 16px;border:2px solid rgba(8,8,25,.2);border-radius:28px;background:#fff;color:#080819;",
    "font:inherit;font-size:14.08px;font-weight:700;line-height:1.2;cursor:pointer;margin:0}",
    ".skqb-pills button::after{content:'';position:absolute;inset:-2px;border-radius:28px;pointer-events:none}",
    ".skqb-pills button[aria-checked=true]::after{box-shadow:0 0 0 2px #080819}",
    ".skqb-pills button.na{background:linear-gradient(to bottom left,transparent calc(50% - 1px),rgba(8,8,25,.2) calc(50% - 1px),rgba(8,8,25,.2) calc(50% + 1px),transparent calc(50% + 1px)) no-repeat,rgba(8,8,25,.05)}",
    ".skqb-pills button.na[aria-checked=true]{border-color:#080819}.skqb-pills button.na[aria-checked=true]::after{box-shadow:none}",
    ".skqb-pills button:focus-visible{outline:3px solid #d51313;outline-offset:3px}",
    "@media (hover:hover){.skqb-pills button:hover::after{box-shadow:0 1px 3px rgba(8,8,25,.4)}.skqb-pills button[aria-checked=true]:hover::after{box-shadow:0 0 0 2px #080819}}",
    ".skqb-note{margin:12px 0 0;font-size:13px;color:#5d5e6e}",
    ".skqb-bar{display:flex;align-items:center;gap:14px;padding:12px 22px calc(14px + env(safe-area-inset-bottom,0px));border-top:1px solid #e3e4e8;background:#fff}",
    ".skqb-price b{display:block;font-size:30px;font-weight:800;color:#080819;font-variant-numeric:tabular-nums;line-height:1.05}",
    ".skqb-price span{font-size:13px;font-weight:600;color:#23743a}.skqb-price span.out{color:#4a4b5c}",
    ".skqb-buy{flex:1;min-height:56px;border:2px solid #d51313;border-radius:28px;background:#d51313;color:#fff;font:inherit;font-size:17px;font-weight:700;cursor:pointer}",
    ".skqb-buy:disabled{background:#e3e4e8;border-color:#e3e4e8;color:#5d5e6e;cursor:not-allowed}",
    ".skqb-buy:focus-visible,.skqb-x:focus-visible{outline:3px solid #d51313;outline-offset:3px}",
    ".skqb-msg{font-size:13px;color:#4a4b5c;padding:0 22px 6px;min-height:0}.skqb-msg:empty{display:none}",
    ".skqb-load{padding:40px 0;text-align:center;color:#5d5e6e}",
    ".skqb-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}",
    ".vs-card [data-var].skqb-hidden{display:none!important}"
  ].join("");

  var root, state = null, cache = {}, lastFocus = null, pushed = false;

  function styles() {     // added at start, so the cards' option lists are hidden before any panel is opened
    if (document.getElementById("skqb-style")) return;
    var st = document.createElement("style"); st.id = "skqb-style"; st.textContent = CSS; document.head.appendChild(st);
  }
  function build() {
    if (root) return;
    styles();
    root = document.createElement("div");
    root.innerHTML = '<div class="skqb-scrim" data-skqb-close></div>' +
      '<section class="skqb" role="dialog" aria-modal="true" aria-labelledby="skqb-title" hidden>' +
      '<div class="skqb-grab"></div><div class="skqb-top"><div class="skqb-kind" data-kind></div>' +
      '<button type="button" class="skqb-x" data-skqb-close aria-label="Close">&times;</button></div>' +
      '<div class="skqb-body"><h2 id="skqb-title" data-title></h2><div class="skqb-pn" data-pn></div>' +
      '<div class="skqb-photo"><img data-img alt=""></div><div data-groups></div></div>' +
      '<div class="skqb-msg" data-msg role="status"></div>' +
      '<div class="skqb-bar"><div class="skqb-price" aria-live="polite"><b data-price></b><span data-stock></span></div>' +
      '<button type="button" class="skqb-buy" data-buy>Add to cart</button></div></section>';
    document.body.appendChild(root);
    root.addEventListener("click", onPanelClick);
    document.addEventListener("keydown", function (e) {
      if (!state) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key === "Tab") trapFocus(e);
    });
    window.addEventListener("popstate", function () { if (state) { pushed = false; close(true); } });
  }

  function trapFocus(e) {
    var f = Array.prototype.filter.call($(".skqb", root).querySelectorAll("button:not([disabled]),a[href]"), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- cards ---------- */
  function enhance(scope) {
    var sels = (scope || document).querySelectorAll(".vs-card select[data-var]:not([data-skqb])");
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i], card = sel.closest(".vs-card"), btn = card && card.querySelector("[data-atc]");
      sel.setAttribute("data-skqb", "1");
      if (!btn || sel.options.length < 2) continue;
      sel.classList.add("skqb-hidden");
      btn.setAttribute("data-skqb-open", "1");
      btn.setAttribute("aria-haspopup", "dialog");
      btn.textContent = LABEL;
    }
  }
  // open from the card (capture phase, so the card's own handler does not add the cheapest option first)
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-skqb-open]");
    if (!btn) return;
    if (btn.getAttribute("data-skqb-pass") === "1") { btn.removeAttribute("data-skqb-pass"); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.getAttribute("aria-disabled") === "true") return;      // the card is still adding the last pick
    open(btn.closest(".vs-card"), btn);
  }, true);

  function productUrl(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var u = new URL(a.getAttribute("href"), location.origin);
    return u.pathname.replace(/\/$/, "");
  }
  function load(path) {
    if (!cache[path]) {
      cache[path] = fetch(path + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (err) { delete cache[path]; throw err; });
    }
    return cache[path];
  }

  /* ---------- panel ---------- */
  function open(card, btn) {
    build();
    var path = productUrl(card), sel = card.querySelector("select[data-var]");
    if (!path || !sel) { btn.removeAttribute("data-skqb-open"); sel && sel.classList.remove("skqb-hidden"); btn.textContent = "Add to cart"; return; }
    lastFocus = btn;
    state = { card: card, btn: btn, sel: sel, path: path, p: null, pick: null };
    var panel = $(".skqb", root);
    panel.hidden = false;
    $("[data-kind]", root).textContent = "";
    $("[data-title]", root).textContent = (card.querySelector(".vs-title") || {}).textContent || "";
    $("[data-pn]", root).textContent = "";
    $("[data-img]", root).src = (card.querySelector(".vs-img img") || {}).src || "";
    $("[data-groups]", root).innerHTML = '<div class="skqb-load">Loading options\u2026</div>';
    $("[data-price]", root).textContent = ""; $("[data-stock]", root).textContent = ""; $("[data-msg]", root).textContent = "";
    $("[data-buy]", root).disabled = true; $("[data-buy]", root).textContent = "Add to cart";
    void panel.offsetWidth;                                   // start the slide-up from the closed position
    document.documentElement.classList.add("skqb-open");
    try { history.pushState({ skqb: 1 }, ""); pushed = true; } catch (e) { pushed = false; }
    setTimeout(function () { var x = $(".skqb-x", root); x && x.focus({ preventScroll: true }); }, 50);
    var mine = state;
    load(path).then(function (p) {
      if (state !== mine) return;
      mine.p = p;
      var v = variantById(p, +sel.value) || cheapestAvailable(p) || p.variants[0];
      mine.pick = (v.options || [v.option1, v.option2, v.option3]).filter(function (x) { return x != null; }).slice(0, p.options.length);
      fill();
    }).catch(function () {
      if (state !== mine) return;
      $("[data-groups]", root).innerHTML = '<div class="skqb-load">Could not load the options. <a href="' + esc(path) + '">Open the product page</a></div>';
    });
  }
  function close(fromHistory) {
    if (!state) return;
    document.documentElement.classList.remove("skqb-open");
    var panel = $(".skqb", root);
    setTimeout(function () { if (!state) panel.hidden = true; }, 300);
    var back = lastFocus; state = null;
    if (pushed && !fromHistory) { pushed = false; try { history.back(); } catch (e) {} }
    if (back && back.focus) back.focus({ preventScroll: true });
  }

  function opts(v) { return (v.options || [v.option1, v.option2, v.option3]).filter(function (x) { return x != null; }); }
  function variantById(p, id) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i]; return null; }
  function cheapestAvailable(p) {
    var a = p.variants.filter(function (v) { return v.available; }).sort(function (x, y) { return x.price - y.price; });
    return a[0] || null;
  }
  function find(p, pick) {
    for (var i = 0; i < p.variants.length; i++) {
      var o = opts(p.variants[i]), ok = true;
      for (var j = 0; j < pick.length; j++) if (o[j] !== pick[j]) { ok = false; break; }
      if (ok) return p.variants[i];
    }
    return null;
  }

  function fill() {
    var s = state, p = s.p;
    var title = String(p.title || ""), cut = title.search(/\s*\|\s*PN\b/i);
    var head = (cut > 0 ? title.slice(0, cut) : title).replace(/\s*\|\s*/g, " ");
    var tail = cut > 0 ? title.slice(cut).replace(/^\s*\|\s*/, "") : "";
    $("[data-kind]", root).textContent = [p.vendor, p.type].filter(Boolean).join(" \u00b7 ");
    $("[data-title]", root).textContent = head;
    $("[data-pn]", root).innerHTML = (tail ? esc(tail) + " \u00b7 " : "") + '<a href="' + esc(s.path) + '">Product details</a>';
    paint();
  }

  function paint() {
    var s = state, p = s.p;
    var html = p.options.map(function (o, d) {
      var name = typeof o === "string" ? o : o.name;
      var values = (o.values && o.values.length) ? o.values : unique(p.variants.map(function (v) { return opts(v)[d]; }));
      var pills = values.map(function (val) {
        // like Shopify themes: a choice is crossed out only if nothing with it is in stock given the choices ABOVE it
        var ok = p.variants.some(function (v) {
          var o = opts(v); if (!v.available || o[d] !== val) return false;
          for (var j = 0; j < d; j++) if (o[j] !== s.pick[j]) return false;
          return true;
        });
        var on = s.pick[d] === val;
        return '<button type="button" role="radio" aria-checked="' + on + '" data-d="' + d + '" data-v="' + esc(val) + '"' +
          (ok ? "" : ' class="na"') + ">" + esc(val) + (ok ? "" : '<span class="skqb-sr"> (sold out)</span>') + "</button>";
      }).join("");
      return '<fieldset class="skqb-group"><legend>' + esc(name) + '</legend><div class="skqb-pills" role="radiogroup">' + pills + "</div></fieldset>";
    }).join("") + (NOTE ? '<p class="skqb-note">' + NOTE + "</p>" : "");
    $("[data-groups]", root).innerHTML = html;
    var v = find(p, s.pick);
    var buy = $("[data-buy]", root), stock = $("[data-stock]", root);
    $("[data-price]", root).textContent = v ? money(v.price) : "";
    stock.textContent = v ? (v.available ? "In stock" : "Sold out") : "Unavailable";
    stock.className = v && v.available ? "" : "out";
    buy.disabled = !(v && v.available);
    buy.textContent = v && v.available ? "Add to cart" : "Sold out";
    var sib = v && p.options.length > 1 && p.variants.filter(function (x) { return x.featured_image && opts(x)[0] === opts(v)[0]; })[0];
    var im = (v && v.featured_image && v.featured_image.src) || (sib && sib.featured_image.src) || p.featured_image;
    if (im) $("[data-img]", root).src = img(im, 500);
    $("[data-img]", root).alt = head(p);
  }
  function head(p) { var t = String(p.title || ""), c = t.search(/\s*\|\s*PN\b/i); return (c > 0 ? t.slice(0, c) : t).replace(/\s*\|\s*/g, " "); }
  function unique(a) { var o = []; a.forEach(function (x) { if (x != null && o.indexOf(x) < 0) o.push(x); }); return o; }

  function onPanelClick(e) {
    var a = e.target.closest("a[href]");
    if (a && pushed && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault(); pushed = false; close(true); location.replace(a.href); return;    // no leftover Back step
    }
    if (e.target.closest("[data-skqb-close]")) { close(); return; }
    var b = e.target.closest("[data-d]");
    if (b && state && state.p) {
      var d = +b.getAttribute("data-d"), val = b.getAttribute("data-v"), p = state.p;
      var want = state.pick.slice(); want[d] = val;
      var exact = find(p, want);
      if (exact && exact.available) state.pick = want;
      else {     // like the product page: keep the tapped value, move the other choice to one that is in stock
        var alt = p.variants.filter(function (v) { return v.available && opts(v)[d] === val; }).sort(function (x, y) { return x.price - y.price; })[0];
        alt = alt || (!exact && p.variants.filter(function (v) { return opts(v)[d] === val; })[0]);   // sold out everywhere: show a real option of it
        state.pick = alt ? opts(alt) : want;
      }
      paint();
      var again = root.querySelector('[data-d="' + d + '"][data-v="' + cssq(val) + '"]'); if (again) again.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest("[data-buy]") && state && state.p) addToCart();
  }
  function cssq(s) { return String(s).replace(/["\\]/g, "\\$&"); }

  function addToCart() {
    var s = state, v = find(s.p, s.pick); if (!v || !v.available) return;
    // the card's list only holds options that were in stock when the card was drawn: add this one if it is missing
    if (!Array.prototype.some.call(s.sel.options, function (o) { return +o.value === v.id; })) {
      var o = document.createElement("option"); o.value = String(v.id); o.textContent = opts(v).join(" / "); s.sel.appendChild(o);
    }
    s.sel.value = String(v.id);
    var btn = s.btn;
    btn.setAttribute("data-skqb-pass", "1");
    close();
    btn.click();                                               // the card's own add-to-cart (drawer, bubble, messages)
  }

  /* ---------- watch for result cards (they are drawn after the page loads and on every new search) ---------- */
  function start() {
    styles();
    enhance(document);
    new MutationObserver(function (list) {
      var added = false;
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        // the card's own add-to-cart puts "Add to cart" back on the button afterwards: show "See options" again
        if (t.nodeType === 1 && t.hasAttribute("data-skqb-open") && t.textContent === "Add to cart") t.textContent = LABEL;
        if (list[i].addedNodes.length) added = true;
      }
      if (added) enhance(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  window.StallionQuickBuy = { enhance: enhance };
})();
